export default {
  MuiContainer: {
    root: {}
  }
};
